import { defineMessages } from 'react-intl';

export default defineMessages({
  ariaLabel: {
    id: 'neptune.ClearButton.ariaLabel',
    defaultMessage: 'Clear',
    description: 'Description of clear button',
  },
});
